import axios from '@axios'
import { address, stringUtils, storePagination, sorting, storeDomains } from '@/mixins'
import { clearFormatting } from '@/utils/cnpj-alphanumeric'
import { localListAddItem, localListDeleteItem } from '@/store/utils'

// const image = 'https://dbechope.s3-sa-east-1.amazonaws.com/images_site/Loja_1_Araraquara.jpeg'

const getInitialState = () => ({
  ...storePagination.state(),
  apiData: {
    telephones: [],
  },
  filters: {
    id: '',
    tradingName: null,
    companyName: null,
    cnpj: null,
    publicPlace: null,
    province: null,
    city: null,
    email: null,
    active: null,
    type: null,
    businessModel: null,
    headId: null,
    directorId: null,
    directorCommercialId: null,
    investors: null,
    region: null,
  },
  stores: [],
  heads: [],
  directors: [],
  directorsCommercial: [],
  investors: [],
  deliverySuppliers: [],
  selectedStoreId: null,

  store: {
    id: null,
    active: true,
    activeOnline: false,
    waiterComission: false,
    delivery: true,
    sendLatLngToDeliverySuppliers: false,
    deliveryType: storeDomains.data().storeDeliveryTypesEnum.CITY,
    deliveryOthersCities: false,
    storeDeliveryLocations: [],
    storeDeliverySuppliers: [],
    storeDeliveryPolygons: [],
    storeWaiterComissions: [],
    tradingName: null,
    companyName: null,
    cnpj: null,
    maxProductItemsSell: null,
    maxOrderValue: null,
    maxScheduleDays: null,
    minDeliveryScheduleMinutes: 40,
    lendingInstallationMinutes: 60,
    autoDeliveryEnabled: false,
    lendingScheduleEnabled: false,
    motoboyEnabled: true,
    motoboyAssignmentTimeLimitMinutes: 10,
    stateRegistration: null,
    stateRegistrationOfTaxSubstitute: null,
    municipalInscription: null,
    lockPdvOpening: true,
    purchaseRequisitionEnabled: true,

    // Chave geral do parcelamento. Desligada por padrão: uma política sem lojas associadas
    // alcança a rede inteira, então a adesão precisa ser explícita loja a loja.
    installmentEnabled: false,

    // Desligado por padrão: no POS a transação já foi capturada quando o operador digita o
    // NSU, então o parcelamento fora da política não pode ser recusado, só registrado como
    // divergência. Ligar é uma decisão da loja.
    posInstallmentEnabled: false,
    purchaseRequisitionGenerationDays: [],
    taxCode: null,
    taxRegime: null,
    address: address.data().address,
    telephones: [],
    email: null,
    emailDelivery: null,
    onlinePaymentConfig: {
      pix: false,
      credit: false,
      cash: false,
      wallet: false,
      pixLimit: null,
      creditLimit: null,
      cashLimit: null,
      walletLimit: null,
      payOnPickup: null,
      // Fornecedor do cartão. Vazio usa o parâmetro global; sem os dois, o cartão não é oferecido.
      creditAcquirer: null,
      // Recursos do cartão pela Getnet. Cada um só vale com o parâmetro global ligado.
      creditInstallment: false,
      creditSavedCards: false,
      // Vazio (null) segue o parâmetro global; false desliga mesmo com o global ligado.
      creditThreeDsRequired: null,
      pixBiometric: false,
      pixBiometricLimit: null,
      // Fornecedor do Google Pay / Apple Pay. Vazio é Stripe.
      walletAcquirer: null,
      googlePayGatewayMerchantId: null,
    },
    onlineChatEnabled: null,
    type: null,
    businessModel: null,
    headId: null,
    directorId: null,
    directorCommercialId: null,
    investors: [],
    imageWide: null,
    imageSquare: null,
    invoiceSerialNumber: null,
    digitalCertificateUrl: null,
    digitalCertificatePassword: null,
    freightValues: {
      deliveryRate: null,
      kilometerRate: null,
    },
    beerCoolerIntegrationStoreId: null,
    maxAccountsPayableValueOnPayBox: null,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    getStoreDeliveryLocations(state) {
      return state.store.storeDeliveryLocations.filter(s => !s.isDeleted)
    },

    getStoreDeliverySuppliers(state) {
      return (state.store.storeDeliverySuppliers || []).filter(s => !s.isDeleted)
    },

    getStoreWaiterComissions(state) {
      return state.store.storeWaiterComissions.filter(s => !s.isDeleted)
    },

    imageSquare(state) {
      if (!state.store.imageSquare) return null
      return {
        url: state.store.imageSquare,
        name: state.store.imageSquare,
        type: stringUtils.methods.getFileType(state.store.imageSquare),
        size: 0,
        ext: stringUtils.methods.getFileExtension(state.store.imageSquare),
        urlValue: state.store.imageSquare,
      }
    },
    imageWide(state) {
      if (!state.store.imageWide) return null
      return {
        url: state.store.imageWide,
        name: state.store.imageWide,
        type: stringUtils.methods.getFileType(state.store.imageWide),
        size: 0,
        ext: stringUtils.methods.getFileExtension(state.store.imageWide),
        urlValue: state.store.imageWide,
      }
    },
    digitalCertificate(state) {
      if (!state.store.digitalCertificateUrl) return null
      return {
        url: state.store.digitalCertificateUrl,
        name: state.store.digitalCertificateUrl,
        type: stringUtils.methods.getFileType(state.store.digitalCertificateUrl),
        size: 0,
        ext: stringUtils.methods.getFileExtension(state.store.digitalCertificateUrl),
        urlValue: state.store.digitalCertificateUrl,
      }
    },
    digitalCertificateName(state) {
      return stringUtils.methods.getFileName(state.store.digitalCertificateUrl)
    },
    headOptions(state) {
      return state.heads.map(head => ({
        ...head,
        value: head.id,
        label: head.name,
      }))
    },
    directorOptions(state) {
      return state.directors.map(director => ({
        ...director,
        value: director.id,
        label: director.name,
      }))
    },
    directorCommercialOptions(state) {
      return state.directorsCommercial.map(directorCommercial => ({
        ...directorCommercial,
        value: directorCommercial.id,
        label: directorCommercial.name,
      }))
    },
    /**
     * Fornecedores de delivery ativos que ainda não foram associados à loja.
     */
    availableDeliverySupplierOptions(state) {
      const associatedIds = (state.store.storeDeliverySuppliers || [])
        .filter(s => !s.isDeleted)
        .map(s => s.deliverySupplierId)

      return state.deliverySuppliers
        .filter(supplier => !associatedIds.includes(supplier.id))
        .map(supplier => ({ ...supplier, value: supplier.id, label: supplier.name }))
    },
    investorsOptions(state) {
      return state.investors.map(investor => ({
        value: investor.id,
        label: investor.name,
      }))
    },
  },

  mutations: {
    ...storePagination.mutations,

    SET_STORE_DELIVERY_LOCATIONS(state, deliveryLocations) {
      state.store.storeDeliveryLocations = deliveryLocations
    },
    SET_STORE_DELIVERY_SUPPLIERS(state, deliverySuppliers) {
      state.store.storeDeliverySuppliers = deliverySuppliers
    },
    SET_DELIVERY_SUPPLIERS(state, deliverySuppliers) {
      state.deliverySuppliers = deliverySuppliers
    },
    SET_STORE_WAITER_COMISSIONS(state, waiterComissions) {
      state.store.storeWaiterComissions = waiterComissions
    },

    SET_API_DATA_TELEPHONES(state, telephones) {
      state.apiData.telephones = telephones
    },
    SET_STORES(state, stores) {
      state.stores = stores
    },
    SET_HEADS(state, heads) {
      state.heads = heads
    },
    SET_DIRECTORS(state, directors) {
      state.directors = directors
    },
    SET_DIRECTORS_COMMERCIAL(state, directorsCommercial) {
      state.directorsCommercial = directorsCommercial
    },
    SET_INVESTORS(state, investors) {
      state.investors = investors
    },
    SET_STORE(state, store) {
      // Garante os objetos de configuração aninhados mesmo quando a API os devolve nulos/ausentes,
      // evitando erro de render ao acessar campos como onlinePaymentConfig.pix.
      const defaults = getInitialState().store
      state.store = {
        ...store,
        autoDeliveryEnabled: store.autoDeliveryEnabled ?? false,
        lendingScheduleEnabled: store.lendingScheduleEnabled ?? false,
        motoboyEnabled: store.motoboyEnabled ?? true,
        storeDeliverySuppliers: store.storeDeliverySuppliers ?? [],
        motoboyAssignmentTimeLimitMinutes:
          store.motoboyAssignmentTimeLimitMinutes ?? 10,
        minDeliveryScheduleMinutes: store.minDeliveryScheduleMinutes ?? 40,
        lendingInstallationMinutes: store.lendingInstallationMinutes ?? 60,
        investors: store.investors?.map(investorId => investorId.toString()),
        onlinePaymentConfig: {
          ...defaults.onlinePaymentConfig,
          ...(store.onlinePaymentConfig || {}),
        },
      }
      state.store.imageObject = {
        url: store.image,
        name: store.image,
        type: stringUtils.methods.getFileType(store.image),
        size: 0,
        ext: stringUtils.methods.getFileExtension(store.image),
        urlValue: store.image,
      }
    },
    RESET_FILTERS(state) {
      const { filters } = getInitialState()
      state.filters = filters
    },
    SET_COMPANY_DATA(state, company) {
      state.store.companyId = company.id.toString()
      state.store.address = company.address
      state.store.companyName = company.companyName
      state.store.cnpj = company.cnpj
      state.store.municipalInscription = company.municipalInscription
      state.store.stateRegistration = company.stateRegistration
      state.store.stateRegistrationOfTaxSubstitute = company.stateRegistrationOfTaxSubstitute
      state.store.taxCode = company.taxCode
      state.store.taxRegime = company.taxRegime
      state.store.invoiceLastNumber = company.invoiceLastNumber
      state.store.digitalCertificateUrl = company.digitalCertificateUrl
      state.store.digitalCertificatePassword = company.digitalCertificatePassword
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchStores({ commit, state }) {
      const response = await axios.get('/api/stores', {
        params: {
          id: state.filters.id,
          tradingName: state.filters.tradingName,
          companyName: state.filters.companyName,
          cnpj: clearFormatting(state.filters.cnpj) || null,
          publicPlace: state.filters.publicPlace,
          province: state.filters.province,
          city: state.filters.city,
          email: state.filters.email,
          active: state.filters.active,
          type: state.filters.type,
          businessModel: state.filters.businessModel,
          headId: state.filters.headId,
          directorId: state.filters.directorId,
          directorCommercialId: state.filters.directorCommercialId,
          region: state.filters.region,
          sortBy: sorting.methods.getSorting(state),
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
        },
      })
      commit('SET_STORES', response.data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: response.data.rowCount,
        rowsInCurrentPage: response.data.rowsInCurrentPage,
      })
    },

    // Pausa/retoma o delivery da loja (incidente), reusando o flag Store.Delivery via endpoint
    // dedicado: paused=true desliga o delivery; paused=false retoma.
    async setStoreDeliveryPaused(_, { storeId, paused }) {
      await axios.put(`/api/stores/${storeId}/delivery-pause`, { paused })
    },

    // Edição rápida do tempo mínimo de entrega e do tempo de instalação do comodato a partir da
    // listagem, sem abrir a manutenção da loja (endpoint dedicado que altera só esses campos).
    async setStoreMinDeliveryScheduleMinutes(
      _,
      { storeId, minDeliveryScheduleMinutes, lendingInstallationMinutes },
    ) {
      await axios.put(`/api/stores/${storeId}/min-delivery-schedule-minutes`, {
        minDeliveryScheduleMinutes,
        lendingInstallationMinutes,
      })
    },

    async fetchHeads({ commit }) {
      const response = await axios.get('/api/users/heads', {
        params: {
          pageSize: 0,
          sortBy: 'Name ASC',
        },
      })
      commit('SET_HEADS', response.data.results)
    },

    async fetchDirectors({ commit }) {
      const response = await axios.get('/api/users/directors', {
        params: {
          pageSize: 0,
          sortBy: 'Name ASC',
        },
      })
      commit('SET_DIRECTORS', response.data.results)
    },

    async fetchDirectorsCommercial({ commit }) {
      const response = await axios.get('/api/users/directors-commercial', {
        params: {
          pageSize: 0,
          sortBy: 'Name ASC',
        },
      })
      commit('SET_DIRECTORS_COMMERCIAL', response.data.results)
    },

    async fetchInvestors({ commit }) {
      const response = await axios.get('/api/investors', {
        params: {
          pageSize: 0,
          sortBy: 'Name ASC',
        },
      })
      commit('SET_INVESTORS', response.data.results)
    },

    async fetchStore({ commit }, storeId) {
      const response = await axios.get(`/api/stores/${storeId}`)

      commit('SET_STORE', {
        ...response.data,
        headquartersStoreId: response.data.headquartersStoreId?.toString(),
        companyId: response.data.companyId?.toString(),
      })
      commit('SET_API_DATA_TELEPHONES', response.data?.telephones.map(t => ({ ...t })) || [])
    },

    setCompanyData({ commit }, company) {
      commit('SET_COMPANY_DATA', company)
    },

    addDeliveryLocation({ state, commit }, deliveryLocation) {
      const list = localListAddItem(state.store.storeDeliveryLocations, deliveryLocation)
      commit('SET_STORE_DELIVERY_LOCATIONS', list)
    },
    removeDeliveryLocation({ state, commit }, idOrLocalId) {
      const list = localListDeleteItem(state.store.storeDeliveryLocations, idOrLocalId)
      commit('SET_STORE_DELIVERY_LOCATIONS', list)
    },

    async fetchDeliverySuppliers({ commit }) {
      const response = await axios.get('/api/sales/delivery-suppliers', {
        params: {
          active: true,
          pageSize: 0,
          sortBy: 'Name ASC',
        },
      })
      commit('SET_DELIVERY_SUPPLIERS', response.data.results)
    },

    addDeliverySupplier({ state, commit }, deliverySupplier) {
      const list = localListAddItem(state.store.storeDeliverySuppliers || [], deliverySupplier)
      commit('SET_STORE_DELIVERY_SUPPLIERS', list)
    },
    removeDeliverySupplier({ state, commit }, idOrLocalId) {
      const list = localListDeleteItem(state.store.storeDeliverySuppliers || [], idOrLocalId)
      commit('SET_STORE_DELIVERY_SUPPLIERS', list)
    },
    /**
     * Marca um fornecedor como padrão, garantindo que apenas um permaneça marcado.
     */
    setDefaultDeliverySupplier({ state, commit }, idOrLocalId) {
      const list = (state.store.storeDeliverySuppliers || []).map(item => ({
        ...item,
        isDefault: item.id === idOrLocalId || item.localId === idOrLocalId,
      }))
      commit('SET_STORE_DELIVERY_SUPPLIERS', list)
    },

    addWaiterComission({ state, commit }, waiterComission) {
      const list = localListAddItem(state.store.storeWaiterComissions, waiterComission)
      commit('SET_STORE_WAITER_COMISSIONS', list)
    },
    removeWaiterComission({ state, commit }, idOrLocalId) {
      const list = localListDeleteItem(state.store.storeWaiterComissions, idOrLocalId)
      commit('SET_STORE_WAITER_COMISSIONS', list)
    },

    async clearStore({ commit }) {
      commit('SET_STORE', getInitialState().store)
      commit('SET_API_DATA_TELEPHONES', getInitialState().apiData.telephones)
    },

    resetFilters({ commit }) {
      commit('RESET_FILTERS')
    },
  },
}
